import { ScrollObserver } from './libs/scroll';
import { MobileNav } from './libs/mobile-nav';

document.addEventListener('DOMContentLoaded', function () {
  const main = new Main();
});

class Main {
  constructor() {
    this._observers = [];
    this._init();
  }

  set observers(val) {
    this._observers.push(val);
  }

  get observers() {
    return this._observers;
  }

  _init() {
    // this._scrollIniti();
    this.menu = new MobileNav();
  }

  _scrollIniti() {
    this.observers = new ScrollObserver('#footer', this._menuoutAnimation, {
      rootMargin: '-70px 0px',
      once: false,
    });
    // this.observers = new ScrollObserver('.slow-appear', this._inviewAnimation);
  }
}
